import { RootState } from 'store';

import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import {
  checkIsLoading,
  checkIsLoadingDone
} from 'common/utils/checkLoading';

import { COUNTRIES_STATE } from '../../constants';
import { EMPTY_ARRAY } from 'shared/constants';

const useAvoidedCountriesLoadingStatus = () => {
  return useSelector((state: RootState) => state[COUNTRIES_STATE].avoidedCountries.loadingStatus);
};

export const useIsAvoidedCountriesLoading = () => {
  const avoidedCountriesLoadingStatus = useAvoidedCountriesLoadingStatus();
  return checkIsLoading(avoidedCountriesLoadingStatus);
};

export const useIsAvoidedCountriesDone = () => {
  const avoidedCountriesLoadingStatus = useAvoidedCountriesLoadingStatus();
  return checkIsLoadingDone(avoidedCountriesLoadingStatus);
};

export const useAvoidedCountries = () => {
  return useSelector((state: RootState) => state[COUNTRIES_STATE].avoidedCountries.data);
};

export const useAvoidedCountryList = () => {
  const avoidedCountries = useAvoidedCountries();

  return useMemo(() => (avoidedCountries || EMPTY_ARRAY).map(({ alpha2Code, name }) => ({
    key: alpha2Code,
    value: name
  })), [avoidedCountries]);
};